module.exports = __webpack_public_path__ + "static/media/Icon_menu_event.8f4423c7.svg";